// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "build/js/" + chunkId + "." + {"594":"e169beef","959":"5430d5a9"}[chunkId] + ".js";
};